export default __webpack_public_path__ + "static/media/test3.7b6efc33.png";